// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1fdWA","subheader":"ReorderModal_subheader__2_Bel","listWrap":"ReorderModal_listWrap__2OZZw"};